// extracted by mini-css-extract-plugin
export default {"newsRow":"NewsRow_newsRow__p+QJQ","newsRow_headline":"NewsRow_newsRow_headline__gCpeR","newsRow_postDate":"NewsRow_newsRow_postDate__8P80f"};